// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../../store';
import Heading from '../../../../../generic-components/Heading';
import { ReactComponent as TrashIcon } from '../../../../../assets/billpay/clear-bill-doc.svg';
import { ReactComponent as RotateRightIcon } from '../../../../../assets/billpay/bill-rotate-right.svg';
import { ReactComponent as RotateLeftIcon } from '../../../../../assets/billpay/bill-rotate-left.svg';
import { ReactComponent as UploadBillIcon } from '../../../../../assets/billpay/upload-bill.svg';
import { LiliToolTip } from '../../../../../generic-components/LiliToolTip';
import Button from '../../../../../generic-components/Button';
import { STYLES } from '../consts';
import { ACCEPTED_BILL_TYPES } from '../../../consts';
import { MAX_FILE_SIZE_MB } from '../../AddBill/consts';
import { DropArea } from '../../../../../components/form/DropArea/DropArea';
import { useUploadBillFile } from '../hooks/useUploadBillFile';

const { CREATE_BILL_BODY: { DOC_PREVIEW } } = STYLES;

const actionTypes = {
  rotateLeft: 'ROTATE_LEFT',
  rotateRight: 'ROTATE_RIGHT',
  delete: 'DELETE',
};

const DOCUMENT_ACTIONS = [
  { title: 'CREATE_BILL.DOC_ACTIONS.ROTATE_LEFT', icon: <RotateLeftIcon className={DOC_PREVIEW.TT_TRIGGER_ICON} />, type: actionTypes.rotateLeft },
  { title: 'CREATE_BILL.DOC_ACTIONS.ROTATE_RIGHT', icon: <RotateRightIcon className={DOC_PREVIEW.TT_TRIGGER_ICON} />, type: actionTypes.rotateRight },
  { title: 'CREATE_BILL.DOC_ACTIONS.DELETE', icon: <TrashIcon className={DOC_PREVIEW.TT_TRIGGER_ICON} />, type: actionTypes.delete },
];
export const BillDocumentContainer = () => {
  const billData = useStore(state => state.billData);
  const setBillData = useStore(state => state.setBillData);
  const { t } = useTranslation();
  const isPdf = useMemo(() => billData?.assetType?.includes('pdf'), [billData?.assetType]);
  const shouldShowAsset = useMemo(() => !!(billData?.assetType && billData?.billImageUrl), [billData?.assetType, billData?.billImageUrl]);
  const [rotationAmount, setRotationAmount] = useState<number>(0);

  const { mutateAsync, isLoading } = useUploadBillFile();

  const handleAction = (type: string) => {
    if (type === actionTypes.delete) {
      setBillData({
        ...billData, documentId: '', billImageUrl: '', assetType: '',
      });
    } else if (type === actionTypes.rotateRight) {
      const rotation = rotationAmount + 90;
      setRotationAmount(rotation);
    } else if (type === actionTypes.rotateLeft) {
      const rotation = rotationAmount - 90;
      setRotationAmount(rotation);
    }
  };

  const handleFile = async (files: FileList) => {
    const fileToUpload = files[0];
    const billImageUrl = URL.createObjectURL(fileToUpload);
    const formData = new FormData();
    formData.append('document', fileToUpload);
    const { documentId } = await mutateAsync({ payload: formData });
    setBillData({
      ...billData, billImageUrl, assetType: fileToUpload.type, documentId,
    });
  };

  return (
    <div className={DOC_PREVIEW.WRAPPER}>
      {shouldShowAsset ? (
        <div className={DOC_PREVIEW.DOC_WRAPPER}>
          <div style={{ transform: `rotate(${rotationAmount}deg)` }} className={DOC_PREVIEW.FLOATING_ASSET_WRAPPER}>
            {isPdf
              ? <iframe style={{ border: 'none' }} className={DOC_PREVIEW.ASSET} src={billData.billImageUrl} title='bill-preview' />
              : <img className={DOC_PREVIEW.ASSET} src={billData.billImageUrl} alt='bill-preview' />}
          </div>
          <div className={DOC_PREVIEW.ACTIONS_CONTAINER}>
            {DOCUMENT_ACTIONS.map(action => (
              <LiliToolTip
                toolTipChildren={(<Heading title={t(action.title)} className={DOC_PREVIEW.TT_HEADER} />)}
                childrenClassName={DOC_PREVIEW.TT_CHILDREN_WRAPPER}
              >
                <Button onClick={() => handleAction(action.type)} id='' className={DOC_PREVIEW.TT_TRIGGER} childElement={action.icon} />
              </LiliToolTip>
            ))}

          </div>
        </div>
      ) : <DropArea isLoading={isLoading} acceptedTypes={ACCEPTED_BILL_TYPES} maxFileSizeInMb={MAX_FILE_SIZE_MB} disclaimer={t('UPLOAD_BILL.DROP_AREA_DISCLAIMER')} IconAsProp={UploadBillIcon} onFilesChange={handleFile} /> }
    </div>
  );
};
